import store from "@/store";
import { error, success } from "@/plugins/snack/snack";
import { eventBus } from "@/utils";
import ReviewDocument from "@/modules/model/reviewDocument";
import Profile from "@/modules/application/models/profile";

class License extends ReviewDocument {
  profile = new Profile();
  loading = false;
  approveCaption = "Approve";

  constructor(line) {
    delete line.comments;
    super(line);
  }

  get name() {
    return this.SearchName;
  }

  get reviewerName() {
    let reviewer = store.getters["Setup/reviewers"]
      .filter((r) => r.code === this.assignedReviewUser)
      .shift();
    return reviewer ? reviewer.names : "";
  }

  get comments() {
    return this.membershipComments || [];
  }

  get logs() {
    return this.reviewLogs
      ? this.reviewLogs.map((l) => {
          l["reviewer"] = store.getters["Setup/reviewers"]
            .filter((r) => r.code === l.reviewedBy)
            .shift();

          return l;
        })
      : [];
  }
  loadProfile(loadCPD = false) {
    this.loading = true;
    return store
      .dispatch("Application/getMemberProfile", {
        ProfileID: this.profileID,
      })
      .then((res) => {
        let profile = res.data.data;
        this.profile = new Profile(profile);
        if (loadCPD) {
          Promise.allSettled([
            this.profile.loadSubscription(),
            this.profile.loadCPD(),
          ]);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  loadDocuments() {
    this.loading = true;
    this.profile.loadApplicationDetails(this.Code);
    this.profile.loadAttachments();
    console.log(this.profile.documents);

    eventBus.$emit("open-viewer", this.profile.documents);
    this.loading = false;
  }

  forward(refresh = true) {
    this.loading = true;

    store
      .dispatch("License/forward", { ...this })
      .then(() => {
        if (refresh) {
          store.dispatch("License/getLicenses");
          success(`Successfully Approved`);
        }
        this.loading = false;
      })
      .catch((err) => {
        error(err.response.data.message);
        this.loading = false;
      });
  }

  rewind(refresh = true) {
    this.loading = true;

    store
      .dispatch("License/rewind", { ...this })
      .then(() => {
        if (refresh) {
          store.dispatch("License/getLicenses");
          success("Successfully Approved");
        }
        this.loading = false;
      })
      .catch((err) => {
        error(err.response.data.message);
        this.loading = false;
      });
  }

  hold(refresh = true) {
    this.loading = true;

    store
      .dispatch("License/hold", { ...this })
      .then(() => {
        if (refresh) {
          store.dispatch("License/getLicenses");
          success("Successfully put on hold");
        }

        this.loading = false;
      })
      .catch((err) => {
        error(err.response.data.message);
        this.loading = false;
      });
  }

  decline(refresh = true) {
    this.loading = true;

    store
      .dispatch("License/decline", { ...this })
      .then(() => {
        if (refresh) {
          store.dispatch("License/getLicenses");
          success("Successfully declined");
        }
        this.loading = false;
      })
      .catch((err) => {
        error(err.response.data.message);
        this.loading = false;
      });
  }

  forwardPRB(refresh = true) {
    this.loading = true;

    store
      .dispatch("License/forwardPRB", { ...this })
      .then(() => {
        if (refresh) {
          store.dispatch("License/getLicenses");
          success("Successfully forwarded to PRB");
        }
        this.loading = false;
      })
      .catch((err) => {
        error(err.response.data.message);
        this.loading = false;
      });
  }
}

export default License;
